module.exports = __webpack_public_path__ + "static/media/icon-email.e4050bbf.svg";